import { formatDateTime } from 'Components/Common/TimeStamp';
import DataTable from 'Container/DataTable/DataTableContainer';
import formUrlParams from 'Helpers/urlform';
import { debounce } from 'lodash';
import { Component } from 'react';
import { Link } from 'react-router-dom';
import { toast as toastr } from 'react-toastify';
import Pagination from '../../Components/Pagination';

class Feedback extends Component {

  constructor(props) {
    super(props);
    const model = {
      headers: [
        {
          className:'w-20',
          title: 'ID',
          accessor: 'id',
          cell: (rowDetails)=>{
            const { index, id, content, ...rest } = rowDetails;
            return(
            <td className='w-20' key={ index }>
               <div className='report-user'>
                  <Link to={ { pathname: `/reports/${ id }`,query: rowDetails } }  > { content } </Link>
                </div>
            </td>
            )            
          },
          sortOption: true,
          tooltip: true,
          isDataEncrypted:true
        },
        {
          className:'w-20',
          title: 'Reported By',
          accessor: 'reporterName',
          chooseOption: {
            name: 'reporterNameSearch',
            // Component: 'Search',
            dispatchFunction: this.handleSearch,
          },
          tooltip: true,
          isDataEncrypted: true
        },
         {
          className:'w-20',
          title: 'Email',
          accessor: 'email',
          chooseOption: {
            name: 'emailSearch',
            dispatchFunction: this.handleSearch,
          },
          tooltip: true,
          isDataEncrypted:true
        },
        {
          className:'w-20',
          title: 'Reported User',
          accessor: 'reportedName',
          chooseOption: {
            name: 'reportedNameSearch',
            // Component: 'Search',
            dispatchFunction: this.handleSearch,
          },
          
          tooltip: true,
          isDataEncrypted:true
        },
        {
          className:'w-20',
          title: 'Chat Type',
          accessor: 'type',
          chooseOption: {
            name: 'typeSearch',
            Component: 'DropDown',
            dispatchFunction: this.handleSearchDropDown,
            optionRender: this.createType,
            DropdownText:'All'
          },
          cell: function(rowDetails) {
            const { content,type, index } = rowDetails;
            if (type === 'chat') {
              return <td className='w-20' key={ index }>{ 'Chat' }</td>;
            } else {
              return <td className='w-20' key={ index }>{ 'Group Chat' }</td>;
            }
          },
         
        },
         {
          className:'w-30',
          title: 'Reported Time',
          accessor: 'reportedTime',
          chooseOption: {
            name: 'reportedTimeSearch',
            Component: 'DateTimeRangeComponent',
            dispatchFunction: this.handleDateSearch
          },
          cell: function(rowDetails) {
            const { index, content } = rowDetails;
            return (
              <td key={ index } id='call-date-time' className='w-30'>
               { content && formatDateTime(content) }
              </td>
            );
          },
          // sortOption: { status: true, column: 'reportedTime' },
        },
      ],
      filtered: [ ],
      responseArray: [],
      pageLimit: 10,
      permission: true,
      activeSort: {},
      saveFeedbackFormStatus: false,
      viewPhoto: false,
      feedbackImage: null,
      activeEditData: '',
      deletePopup: false,
      sortRequestBody: [ ],
    }
    this.state = model;
  }

  componentDidMount() {
    const { filtered } = this.state;
    this.props.fetchFeedback();
    // this.props.exportFeedback(filtered);
  }
  handleDateSearch = data => {
    for (const [ key, value ] of Object.entries(data)) {
      const newKey = (key === 'fromDate') ? 'fromDate' : 'toDate';
      this.formUrlParams(newKey,value)
    }
  };
  componentDidUpdate(prevProps, prevState) {
    if(prevState.deletePopup !== this.state.deletePopup) {
      this.setState({ saveFeedbackFormStatus: false }, () => {
        this.setState({ activeEditData: '' });
      });
    }
  }

  getActiveEditData = (data) => {
    if(data.isRead) return;
    const { profile } = this.props;
    const { edit } = profile.Feedback || {};
    if(!edit) {
      toastr.dismiss();
      toastr.error('You dont have permission to edit');
      return;
    }
    this.setState({ saveFeedbackFormStatus: true }, () => {
      if(data !== '') this.setState({ activeEditData: data });
    });
  };

  deletePopupStatus = (status) => {
    this.setState({
      deletePopup: status
    })
  }
  
  handleViewPhoto = (image) => {
    this.setState({ saveFeedbackFormStatus: false, feedbackImage: image, viewPhoto: !this.state.viewPhoto });
  };

  setPageLimit = ( name, value ) => {
    this.formUrlParams(name, value, { pageLimit: value })
  }

  formUrlParams = (name, value, rest) => {
    const { filtered, activeSort } = this.state;
    const filterResponse = formUrlParams(filtered, name, value);
    this.setState({ filtered: filterResponse, ...rest }, () => {
      let updatedFilter = this.state.filtered;
      if(activeSort && activeSort.id){
        updatedFilter = [
          ...this.state.filtered,
          activeSort
        ]
      }
      this.props.fetchFeedback(updatedFilter);
    });
  }

  /**
   * @method closeForm
   * @summary close save domain popup
   * @return { object } updated domain state
   */

  closeForm = () => {
    this.setState({ saveFeedbackFormStatus: false, filtered: [] });
  };

  /**
   * @method debounceEvent
   * @summary used to delay the event for some limit
   * @param {event} event - React onChange event
   * @return { function } debouncedEvent
   */
  debounceEvent(...args) {
    this.debouncedEvent = debounce(...args);
    return (e) => {
      e.persist();
      return this.debouncedEvent(e);
    };
  }

  sortTable = (sortAttribite) => {
    const { sortRequestBody } = this.state;
    const sortBy = sortAttribite.replace('Sort', '');
    let sortType = 'asc';
    const foundObject = this.state.sortRequestBody.find(obj => obj.id === 'orderBy');
    if (foundObject) {
       const sortTypevalue = foundObject.value;
       sortType = sortTypevalue === '' || sortTypevalue === 'desc' ? 'asc' : 'desc';
    } 
     const result = sortAttribite.replace('Sort', '');
     var sortArray = [ { id: 'sortBy', value: result }, { id: 'orderBy', value: sortType } ]
     this.setState({ sortRequestBody: sortArray }, () => {
       this.formUrlSort(sortArray);
     })
    
  }

  formUrlSort = () => {
    const mergedArray = [ ...this.state.filtered, ...this.state.sortRequestBody ];
   const updatedArray = mergedArray.reduce((accumulator, currentValue) => {
      const existingIndex = accumulator.findIndex(item => 
        item.id === currentValue.id
      );
      if (existingIndex === -1) {
        accumulator.push(currentValue);
      } else {
        accumulator[ existingIndex ] = currentValue; // Update the existing item
      }
      return accumulator;
    }, []);
    this.setState({ filtered : updatedArray })
    this.props.fetchFeedback(updatedArray);
  }

  createStatus = () => {
    const statusArray = [ 'Disable', 'Enable' ]
    return statusArray.map((type, index) => {
      return (
          <option key={ index } value={ index }>{type}</option>
      )
    })
  }

  handleSearch = event => {
    const { name, value } = event.target;
    this.formUrlParams(name, value);
  }
  handleSearchDropDown = event => {
    const { name, value } = event.target;
    if (value) {
       const array = {
        'Chat': 'chat',
        'Group Chat': 'Groupchat'
       };
    var filtervalue = array[ value ]
      this.formUrlParams(name, filtervalue);
    } else {
      this.formUrlParams(name, value);
    }
  }

  createType = () => {
    const deviceArray = [ 'Chat', 'Group Chat' ]
    return deviceArray.map((type, index) => {
        return (
            <option key={ index } value={ type }>{type}</option>
        )
    })
}
  createDevicePlatform = () => {
    const deviceArray = [ 'Android', 'Ios' ]
    return deviceArray.map((type, index) => {
        return (
            <option key={ index } value={ type.toLowerCase() }>{ type }</option>
            
        )
    })
  }

  updateActiveQuery = (updatedpagination) => {
    this.setState({
      filtered: [ ...this.state.filtered, ...updatedpagination ],
    });
  };

  render() {
    const { feedback, loading, totalRecords, currentPage, exportFeedbackData } = this.props;
    console.log('fedddd',feedback);
    
    const { saveFeedbackFormStatus, viewPhoto, feedbackImage, activeEditData } = this.state;
    return (
      <>
        <div className='grid pageContainer_inner'>
          <div className='heading-block gap-10'>
            <div className='block_flex'>
              <h4>Reports</h4>
            </div>
          </div>
          <div className='responsive-table ctTableBox'>
            <DataTable
              headers={ this.state.headers }
              data={ feedback }
              noData='No records!'
              loading={ loading }
              sortTable = { this.sortTable }
              className = { `clickable-tr` }
              // clickableTR = { [ { dispachFunction: this.getActiveEditData, parameter: '' } ] }
              activeSort={ this.state.activeSort }
            />
            <Pagination
              handleClick={ this.formUrlParams }
              totalRecords={ totalRecords }
              initialPage={ currentPage }
              setPageLimit={ this.setPageLimit }
              pageLimit={ this.state.pageLimit }
              updateActiveQuery={ this.updateActiveQuery }
            />
          </div>
          {/* <Pagination /> */}
        </div>
      </>
    );
  }
}
export default Feedback;
